<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row v-if="showStorePicker">
          <el-col :md="24">
            <el-form-item :label="$t('대상 매장')">
              <el-select v-model="targetStoreCd" @change="onTargetStoreChange" style="min-width: 240px">
                <el-option
                  v-for="item in siblingStores"
                  :key="item.storeCd"
                  :label="item.primary ? `${item.storeNm} (${$t('대표')})` : item.storeNm"
                  :value="item.storeCd"></el-option>
              </el-select>
              <span class="target-store-hint">{{
                isSiblingContext
                  ? $t('형제 매장의 메뉴를 보고 있습니다. 가격·프린터 설정만 이 매장에서 바꿀 수 있습니다.')
                  : $t('내 매장')
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('카테고리')">
              <!-- 조건이 바뀌면 **1페이지로 돌아간다**([pagedListMixin.searchFirstPage]) — 3페이지를 보다
                   카테고리를 바꾸면 그 3페이지는 다른 결과 집합의 3페이지라 흔히 빈 표가 온다 -->
              <el-select v-model="searchForm.categoryCd" @change="searchFirstPage">
                <el-option key="0" :label="$t('전체')" :value="null"></el-option>
                <el-option
                  v-for="item in category"
                  :key="item.categoryCd"
                  :label="item.categoryNm"
                  :value="item.categoryCd"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('메뉴명')">
              <el-input v-model="searchForm.smenuNm" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('SmenuForStoreSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuForStoreAdd') && !isSiblingContext"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuForStoreUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuForStoreDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('SmenuForStoreUse')"
        :size="size"
        @click="use"
        icon="el-icon-check"
        :disabled="btn.delDisabled"
        >{{ $t('사용') }}</el-button
      >

      <el-button
        v-if="checkAuthActionAccess('SmenuForStoreSearch')"
        :size="size"
        @click="showImg = !showImg"
        icon="el-icon-picture-outline">
        {{ !showImg ? this.$t('이미지 보기') : this.$t('이미지 숨김') }}
      </el-button>

      <!-- 배달 연동 상태 (①) — 조회가 곧 서버의 지연 재계획이라 기본 꺼짐이고, 켠 동안에만 조회한다 -->
      <template v-if="canViewDelivery">
        <el-button :size="size" @click="toggleDelivery" icon="el-icon-s-promotion">
          {{ !showDelivery ? $t('배달 연동 보기') : $t('배달 연동 숨김') }}
        </el-button>
        <el-button v-if="showDelivery" :size="size" @click="goDeliveryOrphans" icon="el-icon-link">
          {{ $t('메뉴 연결') }}
        </el-button>
        <el-button v-if="showDelivery" :size="size" @click="goDeliveryDrifts" icon="el-icon-warning-outline">
          {{ $t('값 차이 해결') }}
        </el-button>
        <el-button v-if="showDelivery" :size="size" @click="goDeliveryMatrix" icon="el-icon-s-grid">
          {{ $t('그룹 매트릭스') }}
        </el-button>
      </template>

      <template v-if="checkAuthActionAccess('SmenuForStoreAdd') || checkAuthActionAccess('SmenuForStoreUp')">
        <el-popover placement="right" width="600" trigger="click">
          <div style="overflow: scroll" :style="{ height: tableHeight > 620 ? 'auto' : tableHeight + 50 + 'px' }">
            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    '* 양식 파일 첫줄 해더 이름 기준으로 데이타 업로드 됩니다. 수정 하시면 업로드 안되거나 오류 발생 할 수 있습니다.'
                  )
                }}
              </div>
            </div>
            <el-button :size="size" @click="downExcel" icon="el-icon-download" style="margin-left: 10px">{{
              $t('업로드 양식 다운로드')
            }}</el-button>

            <el-divider></el-divider>

            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    `* 카테고리명은 이미 등록된 카테고리명을 입력 하시면 자동 매칭 됩니다. 등록된 카테고리명이 없거나 기타 문제로 매칭 안될경우 첫 순번의 카테고리로 설정 됩니다.\n등록된 카테고리 정보가 하나도 없을 경우 메뉴 등록 안됩니다. 콤마로 여러개의 카테고리를 구분 할 수 있습니다.`
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    `* 옵션명은 이미 등록된 옵션명을 입력 하시면 자동 매칭 됩니다. 등록된 옵션명이 없거나 기타 문제로 매칭 안될경우 설정 되지 않습니다.\n옵션명을 공란으로 둔채로 업로드시, 옵션에 첫번째로 등록한 옵션이 자동으로 입력되어 저장됩니다.\n콤마로 여러개의 옵션명을 구분 할 수 있습니다.`
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    '* 메뉴 데이터 업로드를 추가적으로 할 경우, 추가할 메뉴만 양식에 적어 업로드하여야 데이터 중복 등록이 되지 않습니다.'
                  )
                }}
              </div>
              <div>
                {{
                  $t(
                    '* 업로드된 메뉴는 사용 불가능 상태로 설정 됩니다. 메뉴 설정 완료 후 사용 가능 상태로 설정 하여 주십시오.'
                  )
                }}
              </div>
            </div>

            <el-upload
              :show-file-list="false"
              :action="getUpDataUrl"
              with-credentials
              accept="application/vnd.ms-excel"
              :headers="uploadHeaders"
              style="display: inline; margin-left: 10px"
              :on-success="upSuccess"
              :on-error="upError">
              <el-button :size="size" icon="el-icon-upload">{{ $t('메뉴 데이타 업로드') }}</el-button>
            </el-upload>

            <el-divider></el-divider>

            <div style="margin: 10px">
              <div>
                {{
                  $t(
                    '* 이미지 파일명을 메뉴명과 동일 하게 설정 하고 업로드 하시면 해당 메뉴 이미지를 업데이트 하게 됩니다.'
                  )
                }}
              </div>
              <div>{{ $t('* 이미지 사이즈는 200x150필셀을 규격을 준수 하여주십시오.') }}</div>
              <div>{{ $t('* 이미지 파일를 압축 한다음 압축파일을 업로드 하십시오.') }}</div>
            </div>

            <el-upload
              :show-file-list="false"
              :action="getUpImgUrl"
              with-credentials
              accept="application/x-zip-compressed"
              :headers="uploadHeaders"
              style="display: inline; margin-left: 10px"
              :on-success="upSuccess"
              :on-error="upError">
              <el-button :size="size" icon="el-icon-upload">{{ $t('메뉴 이미지 업로드') }}</el-button>
            </el-upload>
          </div>

          <el-button slot="reference" :size="size" icon="el-icon-upload">{{ $t('메뉴 업로드') }}</el-button>
        </el-popover>
      </template>
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>

      <el-table-column :label="$t('이미지')" prop="smenuImg" width="62" v-if="showImg">
        <template slot-scope="scope">
          <fallback-image
            style="width: 40px; height: 30px"
            :src="resolvImage(scope.row.smenuImg)"
            fit="fill"></fallback-image>
        </template>
      </el-table-column>

      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 페이징된 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 한 장이 서로 다른 말을 한다. 그래서 서버가 정렬할 수 있는 열에만 머리글을
           둔다: 조립 문자열 열(재료·옵션·할인)과 판매 정지 두 열은 정렬 축에서 뺐다 -->
      <el-table-column :label="$t('메뉴명')" prop="smenuNmLan" min-width="200" sortable="custom" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" @click="clickUp(scope.row)"
            ><i class="el-icon-edit-outline"></i>&nbsp;{{ scope.row.smenuNmLan }}</el-button
          >
        </template>
      </el-table-column>
      <!-- 배달 연동 (①) — 플랫폼별 chip. 통합 성공 boolean 이 아니다 (§9.2) -->
      <el-table-column :label="$t('배달 연동')" min-width="260" v-if="showDelivery">
        <template slot-scope="scope">
          <template v-if="deliveryStatusOf(scope.row)">
            <delivery-menu-chip
              v-for="p in deliveryStatusOf(scope.row).platforms"
              :key="p.platform + '-' + (p.linkId || 'none')"
              :status="p"
              @select="onDeliveryChip(scope.row, $event)" />
          </template>
          <span v-else class="dm-loading">{{ $t('불러오는 중…') }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('표시 순서')" prop="ord" min-width="130" align="center" sortable="custom">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.ord"
            @change="handleChangeOrd(scope.row)"
            :min="1"
            :max="99999"
            size="mini"
            style="width: 90px"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('카테고리명')"
        prop="categorysNm"
        min-width="200"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('판매 방식')"
        prop="salesTpNms"
        min-width="140"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('메뉴 재료')" prop="stuffsNm" min-width="200" show-overflow-tooltip></el-table-column>
      <!-- 옵션명은 서버가 **요약형**(앞 5개 + 「외 n개」)으로 내린다 — 셀은 받은 문자열을 그대로 그린다 -->
      <el-table-column
        :label="$t('메뉴 옵션')"
        prop="smenuOptsNm"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('메뉴 할인')"
        prop="discountsNm"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('원가')"
        prop="cost"
        min-width="100"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        :label="$t('단가')"
        prop="priceLan"
        min-width="100"
        align="right"
        sortable="custom"
        :formatter="mainVue.formatterPrice"></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        sortable="custom"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('부가세')"
        prop="vatTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('봉사료')"
        prop="serviceCostTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('바코드')"
        prop="barcode"
        min-width="110"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('판매 정지')" prop="stopSelling" min-width="100" align="center">
        <template slot-scope="scope">{{ scope.row.stopSelling ? 'O' : '' }}</template>
      </el-table-column>
      <el-table-column
        :label="$t('판매 정지 사유')"
        prop="stopReasonNm"
        min-width="200"
        show-overflow-tooltip></el-table-column>
      <!--		<el-table-column :label="$t('키오스크 노출 여부')" 	prop="availableInKiosk" 	min-width="150" align="center" sortable>-->
      <!--			<template slot-scope="scope">{{ scope.row.availableInKiosk ? 'O' : '' }}</template>-->
      <!--		</el-table-column>-->
      <!--		<el-table-column :label="$t('주방 프린터 출력')" 	prop="availableKitchenPrinter" 	min-width="150" align="center" sortable>-->
      <!--			<template slot-scope="scope">{{ scope.row.availableKitchenPrinter ? 'O' : '' }}</template>-->
      <!--		</el-table-column>-->
      <!--		<el-table-column :label="$t('재고 관리 사용')" 	prop="availableSmenuStockManagement" 	min-width="150" align="center" sortable>-->
      <!--			<template slot-scope="scope">{{ scope.row.availableSmenuStockManagement ? 'O' : '' }}</template>-->
      <!--		</el-table-column>-->
      <!--		<el-table-column :label="$t('재고 없을때 판매')" 	prop="availableSellWithoutStock" 	min-width="150" align="center" sortable>-->
      <!--			<template slot-scope="scope">{{ scope.row.availableSellWithoutStock ? 'O' : '' }}</template>-->
      <!--		</el-table-column>-->
      <!--		<el-table-column :label="$t('재고')" 		prop="stock" 	min-width="100" align="right" sortable :formatter="mainVue.formatterPrice"></el-table-column>-->
      <el-table-column
        :label="$t('키오스크 라벨')"
        prop="kioskLabelTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('설명')" prop="smenuDesc" min-width="200" show-overflow-tooltip></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <!--
          공유 메뉴 사본의 **정체성 잠금** (규약 §3.3 · 샵인샵 06 §5 · open-issues ADMIN-2).
          이름·설명·이미지는 원본이 결정하며 저장해도 서버가 되돌린다 — 입력을 열어 두면
          사용자는 저장이 먹은 줄 안다. 배달 링크 키(`menu_name_key`)가 이 이름에서 나오므로
          사본 이름이 원본과 어긋나면 링크가 끊긴다.
        -->
        <el-alert
          v-if="isCopyMenu"
          :title="
            $t(
              '공유 메뉴 사본입니다. 이름·이미지·설명은 원본 메뉴에서 관리하며 여기서는 수정할 수 없습니다. 가격·프린터 설정만 이 매장에서 오버라이드됩니다.'
            )
          "
          type="info"
          show-icon
          :closable="false"
          style="margin-bottom: 10px" />
        <el-tabs v-model="activiTabSmenu">
          <el-tab-pane :label="$t('기본 정보')" name="info">
            <el-row :gutter="20">
              <el-col :md="inputForm.smenuInfos.length > 0 ? 16 : 24">
                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('메뉴 이미지')" :error="formError['smenuImgFile']" required>
                      <el-upload
                        action=""
                        class="avatar-uploader"
                        accept="image/*"
                        list-type="picture-card"
                        :limit="1"
                        :auto-upload="false"
                        :disabled="isCopyMenu"
                        :on-change="smenuImgChange"
                        :on-remove="smenuImgRemove"
                        ref="fileRef">
                        <fallback-image
                          native
                          v-if="inputForm.smenuImgFile !== ''"
                          :src="this.resolvImage(inputForm.smenuImgFile)"
                          class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">
                          {{ $t('200x150 픽셀 이미지만 업로드 가능합니다.') }}
                        </div>
                      </el-upload>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('메뉴명')" :error="formError.smenuNm" required>
                      <div v-if="isCopyMenu" class="identity-locked-hint">
                        {{ $t('원본 메뉴에서 관리합니다.') }}
                        <el-button type="text" :size="size" @click="openOriginalMenu">{{
                          $t('원본 메뉴 열기')
                        }}</el-button>
                      </div>
                      <el-input
                        v-model="inputForm.smenuNm"
                        maxlength="50"
                        clearable
                        show-word-limit
                        :disabled="isCopyMenu">
                        <el-button
                          v-if="lans.length > 1"
                          slot="append"
                          :size="size"
                          @click="dictionaryDialogFormVisible = true"
                          icon="el-icon-search"
                          >{{ $t('다국어 조회') }}</el-button
                        >
                      </el-input>

                      <!-- 사전 선택 -->
                      <DictionaryDialog
                        :visible="dictionaryDialogFormVisible"
                        @close="dictionaryDialogFormVisible = false"
                        @selectDictionary="selectDictionary" />
                    </el-form-item>

                    <el-form-item :label="$t('표시 순서')" :error="formError.ord" required>
                      <el-input-number v-model="inputForm.ord" :min="1" :max="99999"></el-input-number>
                    </el-form-item>

                    <el-form-item
                      v-if="!inputForm.availableMarketPrice"
                      :label="$t('원가')"
                      :error="formError.cost"
                      required>
                      <el-input-number
                        v-model="inputForm.cost"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>

                    <el-form-item
                      v-if="!inputForm.availableMarketPrice"
                      :label="$t('단가')"
                      :error="formError.price"
                      required>
                      <el-input-number
                        v-model="inputForm.price"
                        :step="100"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('메뉴 옵션')">
                      <opt-select
                        :data="smenuOpt"
                        :model="inputForm.smenuOpts"
                        @change="inputForm.smenuOpts = $event"></opt-select>
                      <!--
                        **배달앱에 무엇이 나가는지를 값을 정하는 이 자리에서 말한다** (§16.198).

                        여기가 사장님이 옵션그룹을 붙이고 떼는 유일한 자리이고, 그 편집은 이제 배민·
                        쿠팡이츠로 나간다. 반영 여부는 `배달 연동 상태` 에서 사후에 읽히지만 **경계를
                        모른 채 편집하는 것을 막을 수 있는 자리는 여기뿐**이다 — 옵션 *이름* 을 고쳐
                        두고 반영을 기다리는 것이 이 안내가 없을 때 벌어지는 일이다. §16.177 이 포장
                        가격에 대해 세운 규칙("목표를 정하는 화면에서 조건을 말한다")의 옵션 축 적용이다.

                        **배달 링크가 있을 때만 뜬다**(`showDeliveryChannelPrice` — 배달앱 가격 탭과
                        같은 근거). 링크가 없는 매장이 대다수이고 그들에게 이 축은 존재하지 않는 사실이라,
                        늘 띄우면 없는 걱정을 만든다.
                      -->
                      <div
                        v-for="(note, i) in showDeliveryChannelPrice ? optionOutboundScopeNotes : []"
                        :key="'opt-scope-' + i"
                        class="delivery-outbound-hint">
                        {{ note }}
                      </div>
                      <!--
                        **여러 배달앱에 올라간 메뉴만 읽는 문장** (§16.201) — 위 문단과 나란히 서되
                        조건이 다르다. 위는 「이 축이 어디까지 나가는가」이고 이것은 「이 메뉴에서는
                        그마저 마지막 가져오기에만 붙는다」라 한 곳뿐인 매장에는 없는 사실이다.
                      -->
                      <div v-if="optionMultiPlatformNote" class="delivery-outbound-hint">
                        {{ optionMultiPlatformNote }}
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('카테고리')" :error="formError.categorys" required>
                      <category-combo
                        :data="category"
                        :model="inputForm.categorys"
                        @change="inputForm.categorys = $event"></category-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('칼로리')" :error="formError.calorie">
                      <el-input-number v-model="inputForm.calorie" :step="10" :min="0" :max="999999"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item
                      v-if="!inputForm.availableMarketPrice"
                      :label="$t('할인 설정')"
                      :error="formError.discounts">
                      <discount-combo
                        :data="discount"
                        :label="$t('전체')"
                        :model="inputForm.discounts"
                        @change="inputForm.discounts = $event"></discount-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('판매 방식')" :error="formError.salesTps" required>
                      <mcode-combo
                        :data="salesTp"
                        :model="inputForm.salesTps"
                        @change="inputForm.salesTps = $event"></mcode-combo>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('사용 가능 여부')" required>
                      <combo
                        :data="mainVue.code.useYn"
                        :model="inputForm.useYn"
                        @change="inputForm.useYn = $event"></combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('싯가 적용 여부')">
                      <el-switch v-model="inputForm.availableMarketPrice"></el-switch>
                      <span></span>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('성인 인증 필요')">
                      <el-switch v-model="inputForm.requiresAdultVerification"></el-switch>
                      <span></span>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item :label="$t('설명')" :error="formError.smenuDesc">
                  <el-input
                    v-model="inputForm.smenuDesc"
                    type="textarea"
                    maxlength="250"
                    :disabled="isCopyMenu"></el-input>
                </el-form-item>

                <!-- 원산지 표기·알레르기 표기·메뉴 태그 — 사업장·대행 「메뉴 관리」와 같은 패널이다 -->
                <SmenuLabelingPanel v-model="inputForm" :formError="formError" />
              </el-col>
              <el-col :md="8" v-if="inputForm.smenuInfos.length > 0">
                <el-tabs v-model="activiTab">
                  <el-tab-pane
                    v-for="(item, index) in inputForm.smenuInfos"
                    :key="item.lanTp.id"
                    :label="item.lanTp.nm"
                    :name="item.lanTp.id">
                    <el-form-item
                      :label="$t('메뉴명')"
                      :error="formError['smenuInfos[' + index + '].smenuInfoNm']"
                      required>
                      <el-input
                        v-model="inputForm.smenuInfos[index].smenuInfoNm"
                        maxlength="50"
                        clearable
                        show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item
                      :label="$t('단가')"
                      :error="formError['smenuInfos[' + index + '].price']"
                      required
                      v-if="internationalPayYn">
                      <el-input-number
                        v-model="inputForm.smenuInfos[index].price"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane :label="$t('재료 설정')" name="stuff">
            <StuffSettingPanel v-model="inputForm" :stuff="stuff" />
          </el-tab-pane>

          <el-tab-pane :label="$t('포스 전용 설정')" name="pos">
            <el-row :gutter="20">
              <el-col :md="24">
                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('부가세')" :error="formError.vatTp" required>
                      <code-combo
                        :data="vatTp"
                        :model="inputForm.vatTp"
                        @change="inputForm.vatTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('봉사료')" :error="formError.serviceCostTp" required>
                      <code-combo
                        :data="serviceCostTp"
                        :model="inputForm.serviceCostTp"
                        @change="inputForm.serviceCostTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('바코드')" :error="formError.barcode">
                      <el-input v-model="inputForm.barcode" maxlength="30" clearable show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('키오스크 라벨')" :error="formError.kioskLabelTp" required>
                      <code-combo
                        :data="kioskLabelTp"
                        :model="inputForm.kioskLabelTp"
                        @change="inputForm.kioskLabelTp = $event"></code-combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('주방 프린터 출력')">
                      <el-switch v-model="inputForm.availableKitchenPrinter"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('재고 관리 사용')">
                      <el-switch v-model="inputForm.availableSmenuStockManagement"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('재고 없을 때 판매')">
                      <el-switch v-model="inputForm.availableSellWithoutStock"></el-switch>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('재고')" :error="formError.stock">
                      <el-input-number
                        v-model="inputForm.stock"
                        :step="1"
                        :min="0"
                        :max="90000000"
                        style="width: 200px"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('판매 정지 여부')">
                      <el-switch v-model="inputForm.stopSelling"></el-switch>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('키오스크 노출 여부')">
                      <el-switch v-model="inputForm.availableInKiosk"></el-switch>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('판매 정지 사유')">
                      <code-combo
                        :data="stopReason"
                        :model="inputForm.stopReason"
                        @change="inputForm.stopReason = $event"
                        :disabled="!inputForm.stopSelling"></code-combo>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('기타 사유')" :error="formError.otherReason">
                      <el-input
                        v-model="inputForm.otherReason"
                        maxlength="50"
                        clearable
                        show-word-limit
                        :disabled="
                          !inputForm.stopSelling || null == inputForm.stopReason || 'OTHER' != inputForm.stopReason.val
                        "></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!--
            **배달앱 채널별 가격** (규약 §16.177).

            링크가 하나도 없는 메뉴에는 이 탭 자체가 없다 — 그 사실은 `GET /channel-prices` 응답이
            답하므로 조회를 **부모가** 하고(자식이 붙어 있어야 조회할 수 있는 구조면 탭이 떴다
            사라진다) 링크가 있을 때만 판을 만든다.

            저장 버튼을 따로 두지 않는다. 대신 **메뉴 저장이 성공한 뒤** 이 요청을 보낸다 — 순서가
            반대면 방금 정한 목표가 메뉴 가격 편집의 선언(`MENU_ROW`)에 정리되어 사라진다.
          -->
          <el-tab-pane v-if="showDeliveryChannelPrice" :label="$t('배달앱 가격')" name="deliveryPrice">
            <delivery-menu-channel-price-panel
              ref="deliveryChannelPrice"
              :data="deliveryChannelPrices"
              @saved="onChannelPricesSaved" />
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>

    <!-- 배달 연동 (①) — 상세와 연결 확정. 확정 UI 는 ③ ORPHAN 화면과 같은 컴포넌트다 -->
    <delivery-menu-detail-dialog
      :visible.sync="deliveryDetailVisible"
      :smenu-cd="deliveryDetailSmenuCd"
      :store-cd="deliveryStoreCd"
      @changed="loadDeliveryStatus"
      @open-menu="openDeliveryDetail"
      @bind="openDeliveryBind"
      @go-orphan="goDeliveryOrphans"
      @go-drift="goDeliveryDrifts" />
    <delivery-menu-bind-dialog
      :visible.sync="deliveryBindVisible"
      :link="deliveryBindLink"
      :store-cd="deliveryStoreCd"
      @bound="loadDeliveryStatus" />
  </div>
</template>

<script>
import DictionaryDialog from '@/components/dictionary/DictionaryDialog.vue'
import SmenuLabelingPanel from '@/components/store/SmenuLabelingPanel.vue'
import StuffSettingPanel from '@/components/store/StuffSettingPanel.vue'
import DeliveryMenuChip from '@/components/deliveryMenu/DeliveryMenuChip.vue'
import DeliveryMenuDetailDialog from '@/components/deliveryMenu/DeliveryMenuDetailDialog.vue'
import DeliveryMenuBindDialog from '@/components/deliveryMenu/DeliveryMenuBindDialog.vue'
import DeliveryMenuChannelPricePanel from '@/components/deliveryMenu/DeliveryMenuChannelPricePanel.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { ALL_ROWS_PAGE_SIZE, pageRows, topRowQuery, withPaging } from '@/utils/pagedList'
import { storeLansOf } from '@/utils/storeOptions'
import { downloadExcelFile } from '@/utils/downloadExcelFile'
import { mapGetters } from 'vuex'
import {
  channelPriceSaveSummary,
  DELIVERY_MENU_ACTIONS,
  DELIVERY_MENU_API,
  deliveryLinkedOf,
  deliveryMenuErrorMessage,
} from '@/utils/deliveryMenuSync'
import {
  OPTION_MULTI_PLATFORM_LAST_IMPORT_WINS,
  SOLD_OUT_PLATFORM_DEFAULT,
  deliveryDeleteHidesNote,
  optionOutboundNotes,
} from '@/utils/deliveryMenuNotes'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { smenuLabelingBlank } from '@/utils/smenuLabeling'
import { syncLangValue } from '@/utils/syncLangValue'

export default {
  mixins: [mainVueMixin, pagedListMixin],

  components: {
    DictionaryDialog,
    SmenuLabelingPanel,
    StuffSettingPanel,
    DeliveryMenuChip,
    DeliveryMenuDetailDialog,
    DeliveryMenuBindDialog,
    DeliveryMenuChannelPricePanel,
  },

  data: function () {
    var data = initData()
    data.url = '/smenu/store'
    data.storeLans = []
    data.category = []
    data.salesTp = []
    data.smenuOpt = []
    data.stuff = []
    data.discount = []
    data.stopReason = []
    data.vatTp = []
    data.kioskLabelTp = []
    data.serviceCostTp = []
    data.serviceRate = 0
    data.activiTab = ''
    data.activiTabSmenu = 'info'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    // 다국어 사전 용
    data.lans = []
    data.popTableData = []

    data.dictionaryDialogFormVisible = false
    data.searchText = ''

    data.internationalPayYn = false

    // 이미지 표시 여부
    data.showImg = false

    data.listTitle = this.$t('재료 리스트')
    data.dataTitle = this.$t('재료')
    data.listBtn = this.$t('제거')
    data.dataBtn = this.$t('설정')

    data.closeDialogVisible = false

    // 배달 연동 (①) — 기본 꺼짐. 이 조회가 서버의 지연 재계획을 겸하므로 켠 동안에만 조회한다 (§6.1)
    data.showDelivery = false
    data.deliveryStoreCd = null

    // ── 형제 매장 사본 편집 (ADMIN-2) ────────────────────────────────────
    // 대상 매장 축. **세션에 "현재 작업 매장" 을 담지 않는다** (규약 §3.2·§15 비목표) —
    // 탭을 여러 개 열어 서로 다른 매장을 보면서 같은 화면이라고 믿는 사고를 막기 위한 결정이라
    // 값은 컴포넌트 상태로만 두고 요청마다 명시한다.
    /** 세션 매장 — 그룹 조회의 기준이자 "등록" 이 열리는 유일한 매장 */
    data.sessionStoreCd = null
    /** 지금 보고 있는 매장. `null` 이면 세션 매장(하위호환 — 서버가 미지정을 그렇게 해석한다) */
    data.targetStoreCd = null
    /** `[{storeCd, storeNm, primary}]`. 그룹이 없거나 조회하지 못하면 빈 배열 = 선택기 자체를 감춘다 */
    data.siblingStores = []
    /** smenuCd → `DeliveryMenuStatusRow`. 조회 전에는 비어 있다 */
    data.deliveryStatus = {}
    data.deliveryDetailVisible = false
    data.deliveryDetailSmenuCd = null
    data.deliveryBindVisible = false
    data.deliveryBindLink = null
    /**
     * 이 메뉴의 채널별 목표 가격 (`GET /menus/{smenuCd}/channel-prices`, §16.177).
     * `null` 이면 아직 읽지 않았고, `links` 가 비면 이 메뉴에는 배달 링크가 없다 — 두 경우 다 탭이 없다.
     */
    data.deliveryChannelPrices = null
    return data
  },
  created: function () {
    this.initStore()
    this.search()
    this.initCategory()
    this.initSalesTp()
    this.initSmenuOpt()
    this.initStuff()
    this.initDiscount()
    this.initStopReason()
    this.initVatTp()
    this.initKioskLabelTp()
    this.initServiceCostTp()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {
        // 벨리데이션 메세지가 값은 있는데 Vue에서 표시 안해주는 현상 처리 하기 위함
        setTimeout(
          function () {
            var tmp = this.inputForm.smenuNm
            this.inputForm.smenuNm = this.inputForm.smenuNm + ' '
            this.inputForm.smenuNm = tmp

            var i = 100

            var infoErrors = [
              'smenuImgFile',
              'smenuNm',
              'cost',
              'price',
              'ord',
              'categorys',
              'salesTps',
              'useYn',
              'smenuDesc',
            ]
            var stuffErrors = []
            var posErrors = ['vatTp', 'serviceCostTp', 'barcode', 'kioskLabelTp', 'otherReason']

            var infoError = 0
            var stuffError = 0
            var posError = 0

            for (let val in newVal) {
              if ('' != newVal[val]) {
                if (infoErrors.includes(val)) {
                  infoError++
                } else if (stuffErrors.includes(val)) {
                  stuffError++
                } else if (posErrors.includes(val)) {
                  posError++
                }
              }

              if (val.indexOf('smenuInfos') > -1) {
                if ('' != newVal[val]) {
                  if (i > val.replace(/[^0-9]*/g, '')) {
                    i = parseInt(val.replace(/[^0-9]*/g, ''))
                  }
                }
              }
            }

            if (100 != i) {
              this.activiTab = this.inputForm.smenuInfos[i].lanTp.id
            }

            if (infoError > 0) {
              this.activiTabSmenu = 'info'
            } else if (stuffError > 0) {
              this.activiTabSmenu = 'stuff'
            } else if (posError > 0) {
              this.activiTabSmenu = 'pos'
            }
          }.bind(this),
          500
        )
      },
    },
    // 단가 수정 이벤트 감지
    'inputForm.price': function (newVal) {
      // 타국화페 결제 사용안할때
      if (!this.internationalPayYn) {
        syncLangValue(this.inputForm.smenuInfos, 'price', this.inputForm.price)
      }
    },
    'inputForm.stopSelling': function (newVal) {
      if (!newVal) {
        this.inputForm.stopReason = null
        this.inputForm.otherReason = ''
      } else {
        if (null == this.inputForm.stopReason || null == this.inputForm.stopReason.cd) {
          this.inputForm.stopReason = this.stopReason.length > 0 ? util.copyObj(this.stopReason[0]) : null
        }
      }
    },
    'inputForm.stopReason.val': function (newVal) {
      if ('OTHER' != newVal) {
        this.inputForm.otherReason = ''
      }
    },
    // 이전 이미지 초기화
    dialogFormVisible: function (newVal) {
      if (!newVal) {
        this.inputForm.smenuImgFile = ''
        this.$refs.fileRef.clearFiles()
      }
    },

    showImg: function () {
      this.$nextTick(function () {
        this.$refs.table?.doLayout()
      })
    },

    showDelivery: function () {
      this.$nextTick(function () {
        this.$refs.table?.doLayout()
      })
    },
  },
  computed: {
    // 직접 업로드(`el-upload`)가 싣는 CSRF 헤더 — 스토어가 지금 토큰에서 셈한다(서버가 받는 이름 한 곳)
    ...mapGetters({ uploadHeaders: 'auth/csrfHeaders' }),
    getUpDataUrl: function () {
      return `${this.APP_API_URL}/smenu/store/up`
    },
    getUpImgUrl: function () {
      return `${this.APP_API_URL}/smenu/store/upImg`
    },
    canViewDelivery: function () {
      return checkAuthActionAccess(DELIVERY_MENU_ACTIONS.VIEW)
    },

    // ── 형제 매장 사본 편집 (ADMIN-2) ────────────────────────────────────

    /** 지금 요청에 실을 매장. 고르지 않았으면 세션 매장이다 */
    effectiveStoreCd: function () {
      return this.targetStoreCd != null ? this.targetStoreCd : this.sessionStoreCd
    },

    /** 그룹이 둘 이상일 때만 선택기를 보여준다 — 단독 매장에 빈 축을 만들지 않는다 */
    showStorePicker: function () {
      return this.siblingStores.length > 1
    },

    /** 지금 보고 있는 것이 형제 매장인가 — "등록" 을 닫는 축이다 */
    isSiblingContext: function () {
      return this.effectiveStoreCd != null && this.effectiveStoreCd !== this.sessionStoreCd
    },

    /**
     * 이 메뉴 행이 **공유 메뉴 사본**인가 (규약 §3.3 · 샵인샵 06 §5).
     *
     * 축은 서버가 준 `master_smenu_cd` 하나다 — 프론트가 계보를 다시 계산하지 않는다.
     * 사본의 정체성 필드(이름·설명·이미지)는 원본이 결정하며 저장해도 서버가
     * `applyMasterIdentity` 로 되돌린다. 잠그지 않으면 사용자는 **저장이 먹은 줄 안다.**
     * 가격은 잠그지 않는다 — `price` 가 사본 자율 오버라이드 축(`COPY_SCOPED_FIELDS`)이고
     * 그것이 이 화면이 열려는 바로 그 경로다.
     */
    isCopyMenu: function () {
      return this.inputForm.masterSmenuCd != null
    },

    /**
     * 배달앱 채널별 가격 영역을 보여줄 것인가 (§16.177).
     *
     * **링크가 하나도 없으면 아예 보이지 않는다** — 배달 링크가 없는 매장이 대다수이고, 그들에게는
     * 이 축이 존재하지 않는 사실이다. 판단의 근거는 서버 응답이지 플랫폼 목록이 아니다.
     */
    showDeliveryChannelPrice: function () {
      return (
        this.canViewDelivery &&
        this.deliveryChannelPrices != null &&
        (this.deliveryChannelPrices.links || []).length > 0
      )
    },

    /**
     * 옵션 편집이 배달앱에 어디까지 나가는가 (§16.198).
     *
     * 문구의 정본은 `utils/deliveryMenuNotes` 다 — 이 화면이 문장을 다시 타이핑하면 ① 상세와
     * 두 말을 하게 되고, 경계를 그은 문장에서 그것은 곧 한쪽이 거짓이 된다는 뜻이다.
     */
    optionOutboundScopeNotes: function () {
      // **capability 파생** (§16.214) — 이 메뉴가 실제로 올라간 플랫폼으로 좁힌다.
      var links = (this.deliveryChannelPrices && this.deliveryChannelPrices.links) || []
      var platforms = []
      links.forEach(function (link) {
        if (link && link.platform && platforms.indexOf(link.platform) < 0) platforms.push(link.platform)
      })
      var support = (this.deliveryChannelPrices && this.deliveryChannelPrices.fieldSupport) || []
      return optionOutboundNotes(support, platforms)
    },

    /**
     * **이 메뉴가 배달앱 둘 이상에 올라가 있는가** — 그때만 뜨는 문장이다 (§16.201).
     *
     * 판정 축은 `deliveryChannelPrices.links[].platform` 의 distinct 개수다. 링크가 곧 「그 배달앱에
     * 이 메뉴가 있다」이므로 새 조회가 필요 없고, 이 문단이 뜨는 조건([showDeliveryChannelPrice])이
     * 이미 그 응답을 요구한다. 한 곳뿐인 매장에게는 **존재하지 않는 사실**이라 띄우지 않는다.
     */
    optionMultiPlatformNote: function () {
      const links = (this.deliveryChannelPrices && this.deliveryChannelPrices.links) || []
      const platforms = []
      for (const link of links) {
        const platform = link && link.platform
        if (platform && platforms.indexOf(platform) < 0) platforms.push(platform)
      }
      return platforms.length > 1 ? OPTION_MULTI_PLATFORM_LAST_IMPORT_WINS : null
    },

    /**
     * 삭제 확인창의 배달앱 한 줄 (§16.302) — **오더엔 삭제 = 배달앱 숨김**.
     *
     * 판정 재료는 이 화면이 이미 가진 배달 상태 캐시(`deliveryStatus`, 「배달 연동 보기」를 켰을 때만
     * 찬다)이고 새 조회를 만들지 않는다. 체크한 메뉴 중 하나라도 링크가 있으면 단정하고, 캐시에
     * 없는 메뉴가 있으면(보기를 안 켰거나 권한이 없다) 「모른다」라 조건문이다. 문구는
     * `utils/deliveryMenuNotes` 가 소유한다.
     */
    deliveryDeleteNote: function () {
      const statuses = (this.checkedData || []).map((smenuCd) => this.deliveryStatus[smenuCd] || null)
      const note = deliveryDeleteHidesNote(deliveryLinkedOf(statuses))
      return note ? this.$t(note) : ''
    },
  },
  methods: {
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(기본 50건·첫 페이지·서버 기본 정렬)
    initSearchForm: function () {
      return withPaging({
        categoryCd: null,
        smenuNm: '',
        useYn: 'Y',
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        smenuCd: 0,
        defaultLan: { id: '' },
        smenuNm: '',
        cost: 0,
        price: 0,
        smenuInfos: [],
        categorys: [],
        smenuOpts: [],
        stuffs: [],
        stuffsCds: [],
        discounts: [],
        ord: 0,
        useYn: 'Y',
        smenuImg: '',
        smenuImgFile: '',
        smenuDesc: '',
        calorie: 0,
        stopSelling: false,
        availableInKiosk: true,
        availableKitchenPrinter: true,
        availableSmenuStockManagement: false,
        availableSellWithoutStock: true,
        availableMarketPrice: false,
        requiresAdultVerification: false,
        stock: 0,
        stopReason: null,
        vatTp: null,
        kioskLabelTp: null,
        serviceCostTp: null,
        otherReason: '',
        salesTps: '',
        barcode: '',
        masterSmenuCd: null,
        // 원산지 표기·알레르기 표기·메뉴 태그 — 키는 칸 묶음의 주인(`utils/smenuLabeling`)이 정한다
        ...smenuLabelingBlank(),
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        smenuNm: '',
        cost: '',
        price: '',
        ord: '',
        useYn: '',
        smenuImgFile: '',
        categorys: '',
        smenuDesc: '',
        otherReason: '',
        salesTps: '',
        vatTp: '',
        kioskLabelTp: '',
        serviceCostTp: '',
        barcode: '',
        ...smenuLabelingBlank(),
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].smenuCd
      }
    },
    initStore: function () {
      this.mainVue.$axios.search(
        '/store/getStore',
        null,
        function (result) {
          this.storeLans = result.lans
          this.internationalPayYn = result.internationalPayYn
          // 배달 어드민 API 는 대상 매장을 명시로 받는다 — 세션에 "현재 작업 매장" 을 담지 않는 규약(§3.2)
          this.sessionStoreCd = result.storeCd != null ? Number(result.storeCd) : null
          // 대상 매장을 아직 고르지 않았으면 세션 매장이 곧 대상이다
          this.deliveryStoreCd = this.effectiveStoreCd
          // **그룹 조회는 세션 매장을 안 뒤에만 가능하다** — `created` 에서 부르면 이 응답보다 앞선다
          this.initSiblingStores()
          this.initStoreLans(result)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정 — 순서(기본 언어가 맨 앞)는 [storeLansOf] 한 곳이 소유한다
    initStoreLans: function (store) {
      this.lans = storeLansOf(store)
    },
    /**
     * 대상 매장 후보 — 자기 시블링 그룹 (ADMIN-2).
     *
     * **`GET /api/shop-in-shop/group/{storeCd}` 는 이 화면의 하드 의존이다.** 그 경로는
     * `sys_auth_x_resources` 상 admin·custMng·mng 에만 열려 있었고, §16.152 회차의
     * `sql/db_changes_2026-08-02_shopinshop-group-read.sql` 이 `storeMng` 에게 그 **한 행만**
     * 연다(그룹 매출 `group-sales` 는 닫힌 채로 남는다). **그 SQL 이 적용되지 않은 환경에서는
     * 403 → 강제 로그아웃**이다 — `plugins/http` 인터셉터가 어떤 403 이든 세션을 지우므로
     * `try/catch` 로는 막을 수 없다. 그래서 배포 순서는 **SQL 선적용 → 이 화면 배포**다.
     *
     * 실패하면 선택기를 감춘다(빈 배열) — 단독 매장과 같은 화면이 되어 기존 동작 그대로다.
     */
    initSiblingStores: async function () {
      if (this.sessionStoreCd == null) return
      try {
        const res = await this.$axios.get(`/api/shop-in-shop/group/${this.sessionStoreCd}`, {
          showLoading: false,
          // **이 403 으로 로그아웃하지 않는다** (§16.170). 아래 catch 가 "그룹 없음" 이라는 정상
          // 동작을 이미 갖고 있는데, 인터셉터의 전역 403 처리가 그보다 먼저 세션을 끝내 화면 자체를
          // 열 수 없게 만든다 — 그 좁은 인가 행(§16.152 SQL)이 아직 없는 환경에서 실제로 그랬다.
          logoutOn403: false,
        })
        const group = Array.isArray(res && res.data) ? res.data : []
        // 응답 필드는 `isPrimary` 다 (`ShopInShopService.GroupMember`) — `ShopInShopPanel` 과 같은 축을 읽는다
        this.siblingStores = group.map((m) => ({
          storeCd: Number(m.storeCd),
          storeNm: m.storeNm,
          primary: m.isPrimary === true,
        }))
      } catch (e) {
        // 그룹을 모르는 것은 **과소 스코프이지 오답이 아니다** — 선택기 없이 자기 매장만 본다
        this.siblingStores = []
      }
    },

    /** 대상 매장이 바뀌면 목록·배달 상태를 그 매장으로 다시 읽는다 */
    onTargetStoreChange: function () {
      this.deliveryStoreCd = this.effectiveStoreCd
      this.deliveryStatus = {}
      // 매장이 바뀌면 결과 집합 자체가 다른 것이라 **1페이지부터** 본다
      this.searchFirstPage()
    },

    /** 대상 매장 이름 — 서버가 준 그룹 응답이 유일한 원천이다 */
    storeNameOf: function (storeCd) {
      const hit = this.siblingStores.find((s) => s.storeCd === Number(storeCd))
      return hit ? hit.storeNm : `#${storeCd}`
    },

    // 카테고리 데이타 조회
    initCategory: function () {
      this.mainVue.$axios.search(
        '/category/store',
        { categoryNm: '', useYn: 'Y' },
        function (result) {
          this.category = result
        }.bind(this),
        false
      )
    },
    // 옵션 데이타 조회 — 셀렉트라 **전량**이다([ALL_ROWS_PAGE_SIZE]): 다음 장으로 넘어갈 수단이 없어
    // 한 장이 곧 전부여야 하고, 51번째 옵션이 빠지면 오류가 아니라 「없는 옵션」으로 보인다
    initSmenuOpt: function () {
      this.mainVue.$axios.search(
        '/smenuOpt/store',
        { smenuOptNm: '', useYn: 'Y', pageSize: ALL_ROWS_PAGE_SIZE },
        function (result) {
          this.smenuOpt = pageRows(result)
        }.bind(this),
        false
      )
    },
    // 재료 데이타 조회
    initStuff: function () {
      this.mainVue.$axios.search(
        '/stuff/store',
        { stuffNm: '', useYn: 'Y' },
        function (result) {
          this.stuff = result
        }.bind(this),
        false
      )
    },
    // 할인 데이타 조회
    initDiscount: function () {
      this.mainVue.$axios.search(
        '/discount/store/forMenu',
        null,
        function (result) {
          this.discount = result
        }.bind(this),
        false
      )
    },
    // 판매 정지 사유
    initStopReason: function () {
      this.mainVue.$axios.search(
        '/code/getCode/STOP_REASON',
        null,
        function (result) {
          this.stopReason = result
        }.bind(this),
        false
      )
    },
    // 판매 방식 데이타 초기화
    initSalesTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/SALES_TP',
        null,
        function (result) {
          this.salesTp = result
        }.bind(this)
      )
    },
    // 부가세
    initVatTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/VAT_TP',
        null,
        function (result) {
          this.vatTp = result
        }.bind(this),
        false
      )
    },
    // 봉사료
    initServiceCostTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/SERVICE_COST_TP',
        null,
        function (result) {
          this.serviceCostTp = result
        }.bind(this),
        false
      )
    },
    // 키오스크 라벨 구분
    initKioskLabelTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/KIOSK_LABEL_TP',
        null,
        function (result) {
          this.kioskLabelTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.activiTabSmenu = 'info'
      // 아직 없는 메뉴에는 링크도 채널 목표도 없다 — 앞 메뉴의 값이 남아 보이지 않게 지운다
      this.deliveryChannelPrices = null
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('메뉴 추가')

      this.formError = this.initFormError()

      if (this.storeLans.length > 0) {
        this.inputForm.smenuInfos = []

        for (var i = 0, len = this.storeLans.length; i < len; i++) {
          this.formError['smenuInfos[' + i + '].smenuInfoNm'] = ''
          this.formError['smenuInfos[' + i + '].price'] = ''

          this.inputForm.smenuInfos.push({
            lanTp: this.storeLans[i],
            smenuInfoNm: '',
            price: 0,
          })

          if (i === 0) {
            this.activiTab = this.storeLans[i].id
          }
        }
      }

      this.inputForm.salesTps = this.salesTp
      this.inputForm.smenuImgFile =
        'data:image/png;base64,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'

      // 순번 자동 — 서버에 「이 조건에서 가장 큰 `ord`」 한 행만 묻고 그 다음 수를 쓴다.
      // 화면이 가진 목록으로 세면 **지금 보고 있는 한 장**의 최댓값이라, 2페이지에 더 큰 값이
      // 있어도 모른 채 이미 쓰는 순번을 다시 내준다. 창은 답이 온 뒤에 연다(실패해도 열린다).
      this.fetchNextSequence(
        'ord',
        function (ord) {
          this.inputForm.ord = ord

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this)
      )
    },
    /**
     * 순번 조회에 **지금 보고 있는 매장**을 얹는다 — 형제 매장 선택기가 있는 화면이라 목록의 검색
     * 조건만으로는 어느 매장의 최댓값인지 정해지지 않는다. 묻는 방법 자체는 믹스인이 소유한다.
     */
    sequenceQuery: function (prop) {
      var query = topRowQuery(this.searchForm, prop)

      return this.effectiveStoreCd != null ? Object.assign(query, { storeCd: this.effectiveStoreCd }) : query
    },
    // 메뉴 클릭해서 수정
    clickUp: function (row) {
      this.handleRowClick(row)
      this.up()
    },

    /**
     * 사본 상세에서 **원본 메뉴로 간다** (ADMIN-2 · 규약 §3.3).
     *
     * 정체성 필드를 잠근 자리의 짝이다 — 잠그기만 하고 갈 곳을 주지 않으면 사장님은 이름을 어디서
     * 고치는지 알 수 없다. 원본은 대표 매장에 있으므로 **대상 매장을 함께 되돌린다** — 축은 서버가
     * 준 `masterSmenuCd` 하나이고 프론트가 계보를 다시 계산하지 않는다.
     */
    openOriginalMenu: function () {
      const originalCd = this.inputForm.masterSmenuCd
      if (originalCd == null) return
      const primary = this.siblingStores.find((store) => store.primary)
      this.dialogFormVisible = false
      if (primary && primary.storeCd !== this.effectiveStoreCd) {
        this.targetStoreCd = primary.storeCd
        this.onTargetStoreChange()
      }
      // 목록 갱신은 비동기다 — 그 뒤에 원본 행을 연다
      this.$nextTick(() => {
        this.selectData = { smenuCd: originalCd }
        this.up()
      })
    },
    // 수정
    up: function () {
      // 앞 메뉴의 값을 남기지 않는다 — 응답이 오기 전에는 탭이 없다
      this.deliveryChannelPrices = null
      this.loadDeliveryChannelPrices(this.selectData.smenuCd)
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.smenuCd,
        function (result) {
          this.activiTabSmenu = 'info'
          result.statu = 'U'
          result.title = this.$t('메뉴 수정')
          result.smenuImgFile = result.smenuImg

          // 재료 설정
          result.stuffsCds = []
          for (var i = 0, len = result.stuffs.length; i < len; i++) {
            result.stuffsCds.push(result.stuffs[i].stuffCd)
          }

          this.formError = this.initFormError()

          this.inputForm = result

          // 수정 시 매장 다국어 삭제 시 카테고리도 다국어 지워줌
          var smenuInfosTmp = []

          if (this.inputForm.statu == 'U') {
            smenuInfosTmp = util.copyObj(this.inputForm.smenuInfos)
          }

          this.inputForm.smenuInfos = []

          for (var i = 0, len = this.storeLans.length; i < len; i++) {
            this.formError['smenuInfos[' + i + '].smenuInfoNm'] = ''
            this.formError['smenuInfos[' + i + '].price'] = ''

            var smenuInfoNm = ''
            var price = 0

            if (this.inputForm.statu == 'U') {
              for (var k = 0, klen = smenuInfosTmp.length; k < klen; k++) {
                if (smenuInfosTmp[k].lanTp.id == this.storeLans[i].id) {
                  smenuInfoNm = smenuInfosTmp[k].smenuInfoNm
                  price = smenuInfosTmp[k].price
                }
              }
            }

            this.inputForm.smenuInfos.push({
              lanTp: this.storeLans[i],
              smenuInfoNm: smenuInfoNm,
              price: price,
            })

            if (i === 0) {
              this.activiTab = this.storeLans[i].id
            }
          }

          // ★★ **새 언어 행은 0 으로 태어난다** (`I18N-ROW-SEED`). 위 복사는 **이전 행이 있을
          // 때만** 값을 옮기므로, 매장 언어가 늘어난 회차의 새 행은 `0` 이고 그 뒤 본 값을
          // 고치지 않으면 watcher 가 뜨지 않아 **0 으로 남는다** — 외국어 고객에게 그대로 보인다.
          //
          // 기본값 계산을 여기서 하지 않고 **동기화의 소유자**(`syncLangValue`)를 한 번 부른다.
          // 화면마다 `var price = 본값` 을 적으면 그 계산이 여섯 벌이 되고, `I18N-PRICE-LOOP` 가
          // 없앤 형태가 그대로 재발한다.
          //
          // 타국화폐 결제 매장은 **일부러** 언어별 값을 따로 정하므로 건드리지 않는다.
          if (!this.internationalPayYn) {
            syncLangValue(this.inputForm.smenuInfos, 'price', this.inputForm.price)
          }

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        // **대상 매장을 요청마다 명시한다** (ADMIN-2 · 규약 §9.4) — 미지정은 세션 매장이라
        // 하위호환이 유지된다. 검색 조건 객체 자체에 담지 않는 이유는 그 축이 사용자가 고른
        // 필터가 아니라 **화면의 컨텍스트**이기 때문이다.
        this.effectiveStoreCd != null
          ? Object.assign({}, this.searchQuery(), { storeCd: this.effectiveStoreCd })
          : this.searchQuery(),
        function (result) {
          this.applyPage(result)
          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.formError = this.initFormError()
          // 배달 상태는 **이 페이지에 실린 메뉴만** 묻는다 — `tableData` 가 곧 그 범위다
          this.loadDeliveryStatus()
        }.bind(this),
        false
      )
    },

    // ───────── 배달 3사 메뉴 동기화 (①) ─────────
    // 계약: ordern-workspace/docs/delivery-menu/delivery-menu-sync-contract.md (§9.2)
    // 화면 가이드: ordern-workspace/docs/delivery-menu/delivery-menu-sync-admin-guide.md

    toggleDelivery: function () {
      this.showDelivery = !this.showDelivery
      if (this.showDelivery) this.loadDeliveryStatus()
      else this.deliveryStatus = {}
    },

    deliveryStatusOf: function (row) {
      return this.deliveryStatus[row.smenuCd] || null
    },

    /**
     * 목록에 보이는 메뉴의 플랫폼 상태를 한 번에 읽는다.
     *
     * 이 조회는 읽기 전용이 아니라 서버의 **지연 재계획을 겸한다**(§6.1) — 주기 폴링을 두지 않고
     * 검색·조작 직후에만 부른다. `smenuCds` 를 비우면 서버가 `menus: []` 를 돌려주므로 반드시 싣는다.
     */
    loadDeliveryStatus: async function () {
      if (!this.showDelivery || this.deliveryStoreCd == null) return
      const smenuCds = (this.tableData || []).map((r) => r.smenuCd).filter((cd) => cd != null)
      if (smenuCds.length === 0) {
        this.deliveryStatus = {}
        return
      }
      try {
        const res = await this.$axios.get(`${DELIVERY_MENU_API}/status`, {
          params: { storeCd: this.deliveryStoreCd, smenuCds: smenuCds.join(',') },
          showLoading: false,
        })
        const next = {}
        for (const menu of (res.data && res.data.menus) || []) next[menu.smenuCd] = menu
        this.deliveryStatus = next
      } catch (e) {
        this.deliveryStatus = {}
        this.mainVue.$message({ type: 'error', message: deliveryMenuErrorMessage(e) })
      }
    },

    /**
     * 이 메뉴의 **채널별 목표 가격**을 읽는다 (§16.177).
     *
     * 조회를 자식에게 맡기지 않는 이유는 **링크가 0건이면 그 영역 자체가 없어야 하기** 때문이다 —
     * 자식이 붙어 있어야 조회할 수 있는 구조면 탭이 떴다가 사라진다. `storeCd` 를 싣지 않는 것은
     * 계약이다(메뉴 행은 한 매장의 것이라 서버가 `smenuCd` 에서 파생한다).
     */
    loadDeliveryChannelPrices: async function (smenuCd) {
      if (!this.canViewDelivery || smenuCd == null) return
      try {
        const res = await this.$axios.get(`${DELIVERY_MENU_API}/menus/${smenuCd}/channel-prices`, {
          showLoading: false,
        })
        // 그 사이 다른 메뉴를 열었으면 늦게 온 응답을 버린다
        if (this.selectData && this.selectData.smenuCd === smenuCd) this.deliveryChannelPrices = res.data
      } catch (e) {
        // 문장은 인터셉터가 이미 띄웠다 — 이 축을 읽지 못했다는 사실은 "탭이 없다"로 드러난다
        this.deliveryChannelPrices = null
      }
    },

    /** 저장 응답이 정본이다 — 서버가 접은 결과(메뉴 단가와 같은 값은 `null`)로 편집 상태를 맞춘다 */
    onChannelPricesSaved: function (response) {
      this.deliveryChannelPrices = response
    },

    /**
     * chip 클릭. `AMBIGUOUS` 는 ③ 목록에 오지 않으므로 **여기서 확정한다** — `bind` 는 링크 상태를
     * 가리지 않고 `LINKED` 로 확정하므로 ③과 같은 확정 UI 를 쓴다(가이드 §4).
     */
    onDeliveryChip: function (row, payload) {
      if (payload.chip.resolve === 'BIND' && payload.status.linkId != null) {
        this.openDeliveryBind(payload.status)
        return
      }
      this.openDeliveryDetail(row.smenuCd)
    },

    openDeliveryDetail: function (smenuCd) {
      this.deliveryDetailSmenuCd = smenuCd
      this.deliveryDetailVisible = true
    },

    openDeliveryBind: function (platformStatus) {
      // 확정 대화상자는 ORPHAN 응답 모양을 받는다 — chip 쪽에는 후보가 없으므로 검색으로 고른다
      this.deliveryBindLink = {
        linkId: platformStatus.linkId,
        platform: platformStatus.platform,
        shopNo: platformStatus.shopNo,
        // 이름도 함께 넘긴다 (§16.179) — 대화상자가 `가게` 를 이름으로 읽고, 이 축이 빠지면
        // 같은 대화상자가 ③ 목록에서 열릴 때와 ① chip 에서 열릴 때 다른 말을 한다
        shopNm: platformStatus.shopNm,
        observedName: null,
        observedPrice: null,
        menuNameKey: '',
        observedAt: platformStatus.drift ? platformStatus.drift.observedAt : null,
        candidates: [],
      }
      this.deliveryBindVisible = true
    },

    goDeliveryOrphans: function () {
      this.$router.push('/v/business/delivery-menu/orphans')
    },
    goDeliveryDrifts: function () {
      this.$router.push('/v/business/delivery-menu/drifts')
    },
    goDeliveryMatrix: function () {
      this.$router.push('/v/business/delivery-menu/matrix')
    },
    // 삭제 — 배달 링크가 있으면 배달앱에서는 숨김이 된다(§16.302). 그 사실을 누르기 전에 말한다.
    del: function () {
      this.mainVue
        .$confirm(
          [this.$t('메뉴 정보를 삭제 하시겠습니까?'), this.deliveryDeleteNote].filter(Boolean).join(' '),
          this.mainVue.appMsg.systemAlterTitle,
          {
            confirmButtonText: this.$t('삭제'),
            cancelButtonText: this.$t('취소'),
            type: 'info',
          }
        )
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 반영
    use: function () {
      this.mainVue
        .$confirm(this.$t('메뉴 정보를 사용으로 설정 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('사용'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.up(
              this.url + '/use/' + this.checkedData.join(','),
              null,
              null,
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('사용 설정 성공') })
                // 필터를 바꿨으니 **1페이지부터** 다시 본다 — 3페이지는 다른 결과 집합의 3페이지다
                this.searchForm.useYn = 'Y'
                this.searchFirstPage()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('사용 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      // 재료 설정
      this.inputForm.stuffs = []
      for (var i = 0, len = this.inputForm.stuffsCds.length; i < len; i++) {
        for (var j = 0, jlen = this.stuff.length; j < jlen; j++) {
          if (this.inputForm.stuffsCds[i] == this.stuff[j].stuffCd) {
            this.inputForm.stuffs.push(this.stuff[j])
            break
          }
        }
      }

      for (var i = 0, len = this.inputForm.smenuInfos.length; i < len; i++) {
        this.formError['smenuInfos[' + i + '].smenuInfoNm'] = ''
        this.formError['smenuInfos[' + i + '].price'] = ''
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.afterMenuSaved(this.$t('등록 성공'))
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.smenuCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.afterMenuSaved(this.$t('수정 성공'))
          }.bind(this),
          true
        )
      }
    },

    /**
     * 메뉴 저장이 성공한 뒤 — **채널 목표 가격은 그다음이다** (§16.177).
     *
     * 순서가 계약이다: 계획은 목표를 링크의 오버라이드에서 읽으므로, 채널 목표를 먼저 저장하면 뒤이은
     * 메뉴 가격 편집의 선언(`MENU_ROW`)이 그것을 정리해 방금 정한 값이 사라진다.
     *
     * **부분 실패를 화면이 말한다.** 두 저장은 대상(메뉴 행 / 링크 행)도 실패의 뜻도 달라 응답 하나로
     * "메뉴는 저장됐는데 채널 가격만 범위 밖"을 표현할 자리가 없다 — 그것이 서버가 두 경로를 나눈
     * 이유이기도 하다. 거절 문장은 인터셉터가 이미 띄웠으므로 여기서는 **그것이 모르는 사실**만
     * 덧붙이고, 사장님이 고칠 수 있게 그 탭으로 돌려보낸다.
     */
    afterMenuSaved: async function (message) {
      const panel = this.$refs.deliveryChannelPrice
      const outcome = panel ? await panel.save() : { ok: true, saved: false, response: null }

      if (!outcome.ok) {
        this.mainVue.$message({
          type: 'warning',
          message: this.$t('메뉴는 저장했습니다. 배달앱 채널 가격만 저장하지 못했습니다.'),
          duration: 8000,
        })
        this.activiTabSmenu = 'deliveryPrice'
        this.search()
        return
      }

      const summary = outcome.saved ? ` ${channelPriceSaveSummary(outcome.response)}` : ''

      // ★★ **품절을 켰으면 그 품절의 기한을 말한다** (`SOLDOUT-EXPIRY-MENU-AXIS-UNTOLD`).
      //
      // 배달앱 품절은 **그 앱의 기본 품절**로 나가고 기한이 지나면 스스로 풀린다(§16.243②) —
      // 메뉴 축과 옵션 축이 같은 사실인데 그 문장을 렌더하는 곳은 옵션 토글 하나였다. 그래서
      // 메뉴를 품절한 사장님은 **다음 날 되살아난 것을 우리 결함으로 읽었다.**
      //
      // ★ **판정은 서버가 한다.** 리얼 활성 매장 1,219곳 중 배달 링크가 있는 곳은 9곳이라
      // 무조건 띄우면 99.3% 가 존재하지 않는 숙제를 받는다(§16.230). 옵션 경로가 조건부인
      // 이유와 같고, 그래서 문구만 옮기지 않고 **같은 모양의 답**을 받아서 쓴다.
      const soldOutNote = await this.deliverySoldOutNote()
      this.mainVue.$message(
        soldOutNote
          ? { type: 'success', duration: 8000, showClose: true, message: message + summary + ' ' + soldOutNote }
          : { type: 'success', message: message + summary }
      )
      this.dialogFormVisible = false
      this.search()
    },
    /**
     * 품절을 **켠 저장**일 때만, 그리고 **나갈 배달앱이 있을 때만** 그 문장을 만든다.
     *
     * 해제에는 해당하지 않는 사실이라 켤 때만 묻는다. 조회 실패는 조용히 넘긴다 — 이 화면의
     * 본업은 메뉴 저장이고, 안내 하나 때문에 저장 성공을 흐리지 않는다.
     */
    deliverySoldOutNote: async function () {
      if (!this.inputForm.stopSelling || !this.inputForm.smenuCd) return ''
      try {
        const res = await this.$axios.get(`/api/delivery-menu/menus/${this.inputForm.smenuCd}/soldout-platforms`)
        const platforms = (res && res.data) || []
        return platforms.length ? this.$t(SOLD_OUT_PLATFORM_DEFAULT) : ''
      } catch (e) {
        return ''
      }
    },
    // 이미지 선택
    smenuImgChange: function (file) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data, img) {
          // 200x150이 아니면 메세지 표시
          if (200 != img.width || 150 != img.height) {
            this.mainVue.$message({ type: 'warning', message: this.$t('200x150 픽셀 이미지만 업로드 가능합니다.') })
          } else {
            this.inputForm.smenuImgFile = data
          }
        }.bind(this)
      )
    },
    // 이미지 선택
    smenuImgRemove: function (file, fileList) {
      console.log(file, fileList)
    },
    searchDictionary: function () {
      this.mainVue.$axios.search(
        '/dictionary/search',
        { nm: this.searchText, dictionaryTpVal: 'menu' },
        function (result) {
          this.popTableData = []

          for (var i = 0, len = result.length; i < len; i++) {
            var tmp = result[i]

            tmp[result[i].lan.id] = result[i].nm

            for (var j = 0, jlen = result[i].dictionarys.length; j < jlen; j++) {
              tmp[result[i].dictionarys[j].lan.id] = result[i].dictionarys[j].nm
            }

            this.popTableData.push(tmp)
          }
        }.bind(this),
        true
      )
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          this.inputForm.smenuNm = row[this.lans[i].id]
        } else {
          // 타언어 순서대로 등록
          this.inputForm.smenuInfos[i - 1].smenuInfoNm = row[this.lans[i].id]
        }
      }

      this.dictionaryDialogFormVisible = false
    },
    // 양식 다운로드
    downExcel: function () {
      const url = this.url + '/down'

      downloadExcelFile(url)
    },
    upSuccess: function () {
      this.mainVue.$message({ type: 'success', message: this.$t('업로드 되었습니다') })
      // 필터를 바꿨으니 **1페이지부터** 다시 본다
      this.searchForm.useYn = 'N'
      this.searchFirstPage()
    },
    upError: function () {
      this.mainVue.$message({ type: 'error', message: this.$t('업로드 실패 하였습니다') })
    },
    // 순서 수정
    handleChangeOrd: function (row) {
      this.mainVue.$axios.patchNonLoading(this.url + '/' + row.smenuCd + '/' + row.ord)
    },
  },
}
</script>

<style scoped>
/* 대상 매장 컨텍스트·정체성 잠금 안내 (ADMIN-2) */
.target-store-hint {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}
.identity-locked-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}
.identity-locked-hint .el-button {
  padding: 0 0 0 4px;
}

.el-input-number__decrease,
.el-input-number__increase {
  background: white;
}
.dm-loading {
  color: #c0c4cc;
  font-size: 12px;
}
/* 옵션 편집 자리의 배달앱 반영 경계 안내 (§16.198) */
.delivery-outbound-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>
